import {common} from '@email-manager/services/common';

const services = {
    common,
};

export default services;
